const getters = {
    columnSort: (state) => state.columnSort,
    columnSortByKey: (state) => (sortingPath) => state.columnSort[sortingPath],
}

export default getters